@if (tabSelected === 'indicators') {
  <!-- @todo: imports with dynamic inputs -->
  <button
    matButton="filled"
    [disabled]="!isExportButtonVisible$()"
    (click)="exportIndicators()"
    [matTooltip]="
      !calculationModuleService.isOnlyCMInputs$()
        ? 'title: Export not available with dynamic inputs'
        : null
    "
  >
    <mat-icon>file_download</mat-icon>
    Export indicators
  </button>
}

@if (tabSelected === 'charts') {
  <button matButton="filled" [disabled]="allCharts$().length == 0" (click)="exportGraphic()">
    <mat-icon>file_download</mat-icon>
    Export charts
  </button>
}

<!-- @TODO move it outside of indicators or charts results, next to title RESULTS ? -->
<button
  matButton="filled"
  [disabled]="!isExportButtonVisible$() && allCharts$().length == 0"
  (click)="exportToPdf()"
>
  <mat-icon>picture_as_pdf</mat-icon>
  Export to PDF
</button>
